import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { palette } from "@ptp/look";
import { App } from "./App.js";
import "./styles/global.css";

// Matches the universe's backdrop, so the first paint and a phone without WebGL fit in.
document.documentElement.style.setProperty("--bg", palette.universe.deep);
// The spark's core colour, for highlighting the word in the copy.
document.documentElement.style.setProperty("--spark", palette.sparkCore);

const container = document.getElementById("root");
if (!container) throw new Error("#root missing");

createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
